module.exports = __webpack_public_path__ + "img/6.fa994f13.png";